import { getApiBaseUrl } from 'shared/helper/request';

/**
 * Sign-up verification links are addressed to this site, so that what lands in the
 * researcher's inbox carries the domain they signed up on, but megatron is what spends
 * the token and decides where they go next.
 *
 * Leaving before the app mounts is what keeps the loading screen off a page whose only
 * job is to redirect. Nothing here touches any other route: {@see verificationTokenFromPath}
 * answers null for everything that is not a verification link.
 */
var VERIFICATION_SEGMENT = '/verify-email/';

// The route, optionally language-prefixed, ending in one of megatron's tokens - 32 random
// bytes, hex encoded.
var VERIFICATION_PATH = /^\/(?:(?:br|cn|en|es|jp)\/)?verify-email\/([0-9a-f]{64})\/?$/i;
export var verificationTokenFromPath = function verificationTokenFromPath() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.pathname;
  // Every other page leaves here, before the pattern is evaluated.
  if (pathname.indexOf(VERIFICATION_SEGMENT) === -1) {
    return null;
  }
  var match = pathname.match(VERIFICATION_PATH);
  return match ? match[1] : null;
};
export var verificationUrlForToken = function verificationUrlForToken(token) {
  return "".concat(getApiBaseUrl(), "/api/auth/verify-email/").concat(encodeURIComponent(token));
};
export var redirectToVerification = function redirectToVerification(token) {
  window.location.replace(verificationUrlForToken(token));
};
export default verificationTokenFromPath;